import clsx from "clsx";

export function ModalContainer({visible, children}) {
	return <div className={clsx("overlay", visible && "show")}>{children}</div>;
}
